function normalizeRequiredText(value, fieldName) {
	const normalized = value === undefined || value === null ? "" : String(value).trim();
	if (!normalized) {
		throw new Error(`Unable to delete status item without ${fieldName}.`);
	}
	return normalized;
}

export function buildStatusDeleteRequest({
	isAdministrator = false,
	orgId,
	instanceId,
	url
} = {}) {
	if (!isAdministrator) {
		throw new Error("Only organization administrators can delete status items.");
	}

	const normalizedOrgId = normalizeRequiredText(orgId, "an organization ID");
	const normalizedInstanceId = normalizeRequiredText(instanceId, "an instance ID");
	const normalizedUrl = normalizeRequiredText(url, "a storage URL");
	const expectedSuffix = `_${normalizedInstanceId}.json`;

	if (!normalizedUrl.endsWith(expectedSuffix)) {
		throw new Error("The selected status item storage URL does not match its instance ID.");
	}

	return {
		orgId: normalizedOrgId,
		instanceId: normalizedInstanceId,
		url: normalizedUrl,
		deletionScope: "session"
	};
}

export const STATUS_SESSION_DELETE_UPGRADE_MESSAGE = "The server did not confirm whole-session deletion. Only the selected stored copy was confirmed removed; another copy may remain. Deploy the updated Status deletion backend before retrying. Any remaining selected sessions were not processed.";

export function getStatusDeleteResult(item, response) {
	if (!response || response.success !== true) {
		throw new Error("The server did not confirm deletion. Refresh Status before retrying.");
	}
	if ((response.deletionScope === "session" || response.instanceId) && response.instanceId !== item.instanceId) {
		throw new Error("The server confirmed a different session. Refresh Status before retrying.");
	}
	return {
		...item,
		// Older backend releases only delete the selected physical copy. Never
		// conceal another copy without explicit confirmation of session scope.
		deletionScope: response.deletionScope === "session" ? "session" : "record"
	};
}

export function getStatusDeleteErrorMessage(error) {
	const responseBody = error && error.response && error.response.body;
	if (responseBody && responseBody.message) {
		return responseBody.message;
	}
	if (error && error.message) {
		return error.message;
	}
	return String(error || "Unknown error");
}
